import type chatZh from '../zh/chat';

const chat: typeof chatZh = {
  placeholder: 'Nhập tin nhắn, Enter để gửi, Shift+Enter để xuống dòng',
  send: 'Gửi',
  empty: 'Chưa có tin nhắn, hãy gửi một lời chào',
  idle: 'Chọn hội thoại bên trái để bắt đầu trò chuyện',
  emoji: 'Biểu cảm',
  image: 'Hình ảnh',
  file: 'Tệp đính kèm',
  script: 'Mẫu tin',
  hint_enter: 'Enter để gửi, Shift + Enter để xuống dòng',
  hint_mod: 'Ctrl + Enter để gửi, Enter để xuống dòng',
  hint_ctrl_newline: 'Enter để gửi, Ctrl + Enter để xuống dòng',
  online: 'Trực tuyến',
  no_earlier: 'Không còn tin nhắn cũ hơn',
  new_messages: '{{count}} tin nhắn mới',
  sent: 'Đã gửi',
  delivered: 'Đã chuyển',
  read: 'Đã đọc',
  sending: 'Đang gửi',
  send_failed_retry: 'Gửi thất bại, bấm để gửi lại',
  send_failed: 'Gửi thất bại',
  view: 'Xem',
  today: 'Hôm nay',
  yesterday: 'Hôm qua',
  same_year: '{{day}}/{{month}}',
  full: '{{day}}/{{month}}/{{year}}',
  me: 'Tôi',
  me_prefix: 'Tôi: ',
  self_initial: 'T'
};

export default chat;
